// src/components/PeopleNavigation.jsx
import React from "react";
import PropTypes from "prop-types";
import { 
  UserGroupIcon,
  EnvelopeIcon,
  UserCircleIcon
} from "@heroicons/react/24/solid";

function PeopleNavigation({ activeTab, onTabChange }) {
  return (
    <div className="w-full mt-2 px-2">
      {/* Mobile navigation - full width with equal distribution */}
      <div className="sm:hidden border-b border-gray-200">
        <nav className="flex w-full" aria-label="Tabs">
          <button
            onClick={() => onTabChange("guests")}
            className={`flex-1 text-center border-b-2 py-4 text-base font-medium ${
              activeTab === "guests"
                ? "border-indigo-500 text-indigo-600"
                : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
            }`}
          >
            <div className="flex items-center justify-center">
              <UserGroupIcon className="h-5 w-5 mr-1" />
              <span>Guest Lists</span>
            </div>
          </button>
          <button
            onClick={() => onTabChange("invitations")}
            className={`flex-1 text-center border-b-2 py-4 text-base font-medium ${
              activeTab === "invitations"
                ? "border-indigo-500 text-indigo-600"
                : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
            }`}
          >
            <div className="flex items-center justify-center">
              <EnvelopeIcon className="h-5 w-5 mr-1" />
              <span>Invitations</span>
            </div>
          </button>
          <button
            onClick={() => onTabChange("personal")}
            className={`flex-1 text-center border-b-2 py-4 text-base font-medium ${
              activeTab === "personal"
                ? "border-indigo-500 text-indigo-600"
                : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
            }`}
          >
            <div className="flex items-center justify-center">
              <UserCircleIcon className="h-5 w-5 mr-1" />
              <span>Users</span>
            </div>
          </button>
        </nav>
      </div>
      
      {/* Desktop navigation - left aligned with more spacing */}
      <div className="hidden sm:block border-b border-gray-200">
        <nav className="-mb-px flex space-x-10 pb-1" aria-label="Tabs">
          <button
            onClick={() => onTabChange("guests")}
            className={`whitespace-nowrap border-b-2 py-5 px-2 text-base font-medium ${
              activeTab === "guests"
                ? "border-indigo-500 text-indigo-600"
                : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
            }`}
          >
            <div className="flex items-center">
              <UserGroupIcon className="h-6 w-6 mr-2" />
              <span>Guest Lists</span>
            </div>
          </button>
          <button
            onClick={() => onTabChange("invitations")}
            className={`whitespace-nowrap border-b-2 py-5 px-2 text-base font-medium ${
              activeTab === "invitations"
                ? "border-indigo-500 text-indigo-600"
                : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
            }`}
          >
            <div className="flex items-center">
              <EnvelopeIcon className="h-6 w-6 mr-2" />
              <span>Invitations</span>
            </div>
          </button>
          <button
            onClick={() => onTabChange("personal")}
            className={`whitespace-nowrap border-b-2 py-5 px-2 text-base font-medium ${
              activeTab === "personal"
                ? "border-indigo-500 text-indigo-600"
                : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
            }`}
          >
            <div className="flex items-center">
              <UserCircleIcon className="h-6 w-6 mr-2" />
              <span>Users</span>
            </div>
          </button>
        </nav>
      </div>
    </div>
  );
}

PeopleNavigation.propTypes = {
  activeTab: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
};

export default PeopleNavigation;